import { CALIBRATION_SESSION_SEQUENCE } from './calendarLayout'
import type { CalibrationSessionType, CalibrationStatus } from '../calibrationTypes'

export type CalibrationAdvanceValidation =
  | { ok: true; nextSessionNumber: number }
  | { ok: false; reason: 'already_completed' | 'already_recorded' | 'invalid_sequence' }

export function sessionNumberForType(sessionType: CalibrationSessionType): number {
  return CALIBRATION_SESSION_SEQUENCE.indexOf(sessionType) + 1
}

export function validateCalibrationSessionAdvance(
  sessionType: CalibrationSessionType,
  completedSessions: number,
  calibrationStatus: CalibrationStatus,
  alreadyRecorded: boolean,
): CalibrationAdvanceValidation {
  if (calibrationStatus === 'completed') {
    return { ok: false, reason: 'already_completed' }
  }

  const expectedSessionNumber = sessionNumberForType(sessionType)
  if (expectedSessionNumber < 1) {
    return { ok: false, reason: 'invalid_sequence' }
  }

  if (alreadyRecorded) {
    if (completedSessions >= expectedSessionNumber) {
      return { ok: false, reason: 'already_recorded' }
    }
    return { ok: true, nextSessionNumber: completedSessions }
  }

  if (expectedSessionNumber !== completedSessions + 1) {
    return { ok: false, reason: 'invalid_sequence' }
  }

  return { ok: true, nextSessionNumber: expectedSessionNumber }
}
